import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Wolf silhouette uses the ★1 tier art. The active rendering for
// Ash Wolf goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/new_wolf_3tier.jpg.
export const Wolf = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/wolf-1.png" size={size} alt="wolf" />
)
